// This file is automatically generated by webgen from the struct descriptions in /generated-json/structs.
// Files in /generated-json are created from the structs configured in the 'main' function of /cmd/struct2json/main.go.
//
// DO NOT EDIT THIS FILE except where designated below.

/* eslint-disable no-relative-import-paths/no-relative-import-paths */

// webgen:import { "names": ["CalculateOtherCost", "CalculateSuggestedPrice"], "path": "../../../utils/costCalculations" }
// webgen:import { "wildcardName": "CurrencyHelpers", "path": "../../../utils/currency" }
// webgen:import { "names": ["CalculateMarginCurrencyNumber", "CalculateMarginPercentage", "FormatMarginCurrency", "FormatMarginPercentage"], "path": "../../../utils/marginCalculations" }
// webgen:import { "names": ["CalculateEstimatedYards", "CalculateExtendedPriceCurrency", "CalculatePricePerYard", "FormatEstimatedYards"], "path": "../../../utils/pricingCalculations" }
// webgen:import { "names": ["TenantDefaultMargins", "EmptyTenantDefaultMargins"], "path": "../../tenantDefaultMargins" }

import type { PartialDeep } from 'type-fest';

import { CalculateOtherCost, CalculateSuggestedPrice } from '../../../utils/costCalculations';
import * as CurrencyHelpers from '../../../utils/currency';
import {
  CalculateMarginCurrencyNumber,
  CalculateMarginPercentage,
  FormatMarginCurrency,
  FormatMarginPercentage,
} from '../../../utils/marginCalculations';
import {
  CalculateEstimatedYards,
  CalculateExtendedPriceCurrency,
  CalculatePricePerYard,
  FormatEstimatedYards,
} from '../../../utils/pricingCalculations';
import type { ExcludeMethodsDeep } from '../../../utils/types';
import { EmptyTenantDefaultMargins, TenantDefaultMargins } from '../../tenantDefaultMargins';
import { Currency, type CurrencyWireFormat, NewCurrency } from '../Currency/Currency';
import {
  DeliveryCost,
  type DeliveryCostWireFormat,
  NewDeliveryCost,
} from '../DeliveryCost/DeliveryCost';
import Enums from '../Enums';
import { NewProduct, Product, type ProductWireFormat } from '../Product/Product';
import {
  NewQuoteProductDiscount,
  type QuoteProductDiscount,
  type QuoteProductDiscountWireFormat,
} from '../QuoteProductDiscount/QuoteProductDiscount';
import {
  NewQuoteProductTruckingInfo,
  type QuoteProductTruckingInfo,
  type QuoteProductTruckingInfoWireFormat,
} from '../QuoteProductTruckingInfo/QuoteProductTruckingInfo';
import {
  NewTruckingType,
  type TruckingType,
  type TruckingTypeWireFormat,
} from '../TruckingType/TruckingType';

export class QuoteProduct {
  readonly product: Product;
  readonly discounts: QuoteProductDiscount[];
  readonly kind: Enums.QuoteProductKind;
  readonly quantity: string | null;
  readonly price: Currency;
  readonly class: number | null;
  readonly externalName: string | null;
  readonly deliveryCosts: DeliveryCost;
  readonly usage: string | null;
  readonly deliveryType: Enums.ProductDeliveryType | null;
  readonly truckingType: TruckingType | null;
  readonly additionalTruckingInfos: QuoteProductTruckingInfo[];
  readonly haulRate: Currency | null;
  readonly minimumHaulCharge: number | null;
  readonly taxRate: string | null;
  readonly haulTaxable: boolean;
  readonly haulCost: Currency | null;
  readonly otherCost: Currency;
  readonly materialCost: Currency;
  readonly withDeliverySubtotalPrice: Currency;
  readonly withDeliveryTotalPrice: Currency;
  readonly haulMargin: string;

  constructor(data: { [key: string]: any } = {}) {
    this.product = NewProduct(data.product);
    this.discounts = (data.discounts ?? []).map((discounts: any) =>
      NewQuoteProductDiscount(discounts),
    );
    this.kind = data.kind === undefined ? Enums.QuoteProductKind.Additional : data.kind;
    this.quantity = data.quantity === undefined ? null : data.quantity;
    this.price = NewCurrency(data.price);
    this.class = data.class === undefined ? null : data.class;
    this.externalName = data.externalName === undefined ? null : data.externalName;
    this.deliveryCosts = NewDeliveryCost(data.deliveryCosts);
    this.usage = data.usage === undefined ? null : data.usage;
    this.deliveryType = data.deliveryType === undefined ? null : data.deliveryType;
    this.truckingType =
      // eslint-disable-next-line no-nested-ternary
      (data.truckingType ?? null) === null ? null : NewTruckingType(data.truckingType);
    this.additionalTruckingInfos = (data.additionalTruckingInfos ?? []).map(
      (additionalTruckingInfos: any) => NewQuoteProductTruckingInfo(additionalTruckingInfos),
    );
    this.haulRate = (data.haulRate ?? null) === null ? null : NewCurrency(data.haulRate);
    this.minimumHaulCharge = data.minimumHaulCharge === undefined ? null : data.minimumHaulCharge;
    this.taxRate = data.taxRate === undefined ? null : data.taxRate;
    this.haulTaxable = data.haulTaxable === undefined ? false : data.haulTaxable;
    this.haulCost = (data.haulCost ?? null) === null ? null : NewCurrency(data.haulCost);
    this.otherCost = NewCurrency(data.otherCost);
    this.materialCost = NewCurrency(data.materialCost);
    this.withDeliverySubtotalPrice = NewCurrency(data.withDeliverySubtotalPrice);
    this.withDeliveryTotalPrice = NewCurrency(data.withDeliveryTotalPrice);
    this.haulMargin = data.haulMargin === undefined ? '0' : data.haulMargin;
  }

  static zero(): QuoteProduct {
    const zeroValues: ExcludeMethodsDeep<QuoteProduct> = {
      product: Product.zero(),
      discounts: [],
      kind: Enums.QuoteProductKind.Additional,
      quantity: null,
      price: Currency.zero(),
      class: null,
      externalName: null,
      deliveryCosts: DeliveryCost.zero(),
      usage: null,
      deliveryType: null,
      truckingType: null,
      additionalTruckingInfos: [],
      haulRate: null,
      minimumHaulCharge: null,
      taxRate: null,
      haulTaxable: false,
      haulCost: null,
      otherCost: Currency.zero(),
      materialCost: Currency.zero(),
      withDeliverySubtotalPrice: Currency.zero(),
      withDeliveryTotalPrice: Currency.zero(),
      haulMargin: '0',
    };
    return new QuoteProduct(zeroValues);
  }

  // ************* DO NOT EDIT ABOVE THIS LINE *************

  /** Returns the price * quantity as a Currency */
  extendedPriceCurrency(): Currency {
    const price = this.price.toUnit();
    return CalculateExtendedPriceCurrency(price, this.quantity);
  }

  /** Returns the price * quantity as a string */
  extendedPriceDisplay(): string {
    return CurrencyHelpers.CurrencyString({
      cur: this.extendedPriceCurrency(),
    });
  }

  /** Returns the material costs + locally-calculated other costs. */
  costPerUnit(): Currency {
    return (
      this.product.getMaterialCost().add(this.calculateOtherCost() ?? Currency.zero()) ??
      Currency.zero()
    );
  }

  costPerUnitDisplay(currencyCode?: string | null): string {
    return CurrencyHelpers.CurrencyString({ cur: this.costPerUnit(), currencyCode });
  }

  /** Returns the margin as a number | null */
  margin(): number | null {
    const price = this.price.toUnit();
    const totalCost = this.costPerUnit().toUnit();
    return CalculateMarginPercentage(price, totalCost);
  }

  /** Returns the percentage-based margin as a formatted percentage. */
  marginAsPercentage(): string | null {
    return FormatMarginPercentage(this.margin());
  }

  /** Returns the margin as a formatted currency amount. */
  marginAsFormattedCurrency(currencyCode?: string | null): string | null {
    return FormatMarginCurrency(this.marginAsCurrencyNumber(), currencyCode);
  }

  /** Returns the margin as a currency amount number. */
  marginAsCurrencyNumber(): number | null {
    const price = this.price.toUnit();
    const totalCost = this.costPerUnit().toUnit();
    return CalculateMarginCurrencyNumber(price, totalCost);
  }

  /** Returns the margin over material as a number | null */
  marginOverMaterial(): number | null {
    const price = this.price.toUnit();
    const materialCost = this.product.getMaterialCost().toUnit();
    return CalculateMarginPercentage(price, materialCost);
  }

  getHaulMargin(): number | null {
    const haulRate = this.haulRate?.toUnit() ?? 0;
    const haulCost = this.haulCost?.toUnit() ?? 0;
    return CalculateMarginPercentage(haulRate, haulCost);
  }

  /** Returns the percentage-based margin over material as a formatted percentage. */
  marginOverMaterialAsPercentage(): string | null {
    return FormatMarginPercentage(this.marginOverMaterial());
  }

  haulMarginAsPercentage(): string | null {
    return FormatMarginPercentage(this.getHaulMargin());
  }

  /** Returns the percentage-based margin over material as a formatted currency amount. */
  marginOverMaterialAsFormattedCurrency(currencyCode?: string | null): string | null {
    const price = this.price.toUnit();
    const materialCost = this.product.getMaterialCost().toUnit();
    return FormatMarginCurrency(CalculateMarginCurrencyNumber(price, materialCost), currencyCode);
  }

  /** If product.quantity or quoteProduct.quantity are null, return null. */
  estimatedYards(): number | null {
    return CalculateEstimatedYards(this.quantity, this.product.quantity);
  }

  /** display-friendly thousands-separated `estimatedYards()` */
  estimatedYardsDisplay(): string | null {
    return FormatEstimatedYards(this.estimatedYards());
  }

  /** (price * quantity) / estimatedYards. If estimatedYards is 0 or null, return null */
  pricePerYard(): number | null {
    return CalculatePricePerYard(this.extendedPriceCurrency().number, this.estimatedYards());
  }

  /** display-friendly thousands-separated `pricePerYard()` */
  pricePerYardDisplay(currencyCode?: string | null): string | null {
    const ppy = this.pricePerYard();
    return ppy === null
      ? null
      : CurrencyHelpers.CurrencyString({
          cur: NewCurrency({ number: ppy.toFixed(2) }),
          currencyCode,
        });
  }

  calculateOtherCost(): Currency | null {
    return CalculateOtherCost({
      product: this.product,
      deliveryCosts: this.deliveryCosts,
      otherCostOverride: this.product.otherCostOverride,
    });
  }

  calculateSuggestedPrice(
    marginConfiguration: Enums.MarginConfiguration = Enums.MarginConfiguration.Percentage,
    defaultMargins: TenantDefaultMargins = EmptyTenantDefaultMargins,
  ): Currency | null {
    return CalculateSuggestedPrice({
      product: this.product,
      deliveryCosts: this.deliveryCosts,
      otherCostOverride: this.product.otherCostOverride,
      marginConfiguration,
      defaultMargins,
    });
  }

  // ************* DO NOT EDIT BELOW THIS LINE *************
}

export type QuoteProductWireFormat = {
  product: ProductWireFormat;
  discounts: QuoteProductDiscountWireFormat[];
  kind: string;
  quantity: string | null;
  price: CurrencyWireFormat;
  class: number | null;
  externalName: string | null;
  deliveryCosts: DeliveryCostWireFormat;
  usage: string | null;
  deliveryType: string | null;
  truckingType: TruckingTypeWireFormat | null;
  additionalTruckingInfos: QuoteProductTruckingInfoWireFormat[];
  haulRate: CurrencyWireFormat | null;
  minimumHaulCharge: number | null;
  taxRate: string | null;
  haulTaxable: boolean;
  haulCost: CurrencyWireFormat | null;
  otherCost: CurrencyWireFormat;
  materialCost: CurrencyWireFormat;
  withDeliverySubtotalPrice: CurrencyWireFormat;
  withDeliveryTotalPrice: CurrencyWireFormat;
  haulMargin: string;
};

type NewQuoteProductProps = PartialDeep<QuoteProduct, { recurseIntoArrays: true }>;
export const NewQuoteProduct: (props: NewQuoteProductProps) => QuoteProduct = (props) =>
  new QuoteProduct(props);

type NewQuoteProductFromWireFormatProps = PartialDeep<
  QuoteProductWireFormat,
  { recurseIntoArrays: true }
>;
export const NewQuoteProductFromWireFormat: (
  props: NewQuoteProductFromWireFormatProps,
) => QuoteProduct = (props) => new QuoteProduct(props);
